export const C = {
  teal:   '#015762',
  rose:   '#89445b',
  mint:   '#7dd3c8',
  teal2:  '#0d9488',
  amber:  '#d97706',
  violet: '#7c3aed',
  blue:   '#2563eb',
  t1:     '#0f1c24',
  t2:     '#3d5a6a',
  t3:     '#6b8799',
  tier:   ['#7dd3c8', '#015762', '#d97706', '#89445b'] as string[],
  domain: ['#015762', '#89445b', '#0d9488', '#d97706', '#7c3aed', '#2563eb'] as string[],
  cycle:  ['#0d9488', '#7dd3c8', '#d97706', '#89445b', '#7c3aed', '#94a3b8'] as string[],
  a(hex: string, alpha: number): string {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    return `rgba(${r},${g},${b},${alpha})`
  },
}

export function hmColor(p: number, baseHex: string): { bg: string; text: string } {
  const r1 = parseInt(baseHex.slice(1, 3), 16)
  const g1 = parseInt(baseHex.slice(3, 5), 16)
  const b1 = parseInt(baseHex.slice(5, 7), 16)
  const t = Math.min(p / 60, 1)
  const r = Math.round(255 + (r1 - 255) * t)
  const g = Math.round(255 + (g1 - 255) * t)
  const b = Math.round(255 + (b1 - 255) * t)
  return { bg: `rgb(${r},${g},${b})`, text: t > 0.45 ? '#fff' : C.t1 }
}
